var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaperPlane(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.125 2.41536C20.125 2.33203 20.125 2.2487 20.0375 2.16536V2.08203C20.0375 1.9987 19.95 1.91536 19.8625 1.83203C19.775 1.7487 19.6875 1.7487 19.6 1.66536H19.5125C19.425 1.66536 19.3375 1.66536 19.25 1.58203C19.25 1.66536 19.25 1.66536 19.25 1.66536C19.1625 1.66536 19.075 1.66536 18.9875 1.7487L1.4875 7.58203C1.1375 7.66536 0.875 7.91536 0.875 8.33203C0.875 8.66536 1.05 8.9987 1.4 9.16536L8.925 12.332L12.25 19.4987C12.425 19.832 12.6875 19.9987 13.0375 19.9987C13.3875 19.9987 13.7375 19.7487 13.825 19.4154L19.95 2.7487C20.125 2.66536 20.125 2.58203 20.125 2.41536C20.125 2.4987 20.125 2.4987 20.125 2.41536ZM15.925 4.4987L9.45 10.6654L4.1125 8.41536L15.925 4.4987ZM13.0375 16.9154L10.675 11.832L17.15 5.66536L13.0375 16.9154Z",
    fill: "#868B91"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperPlane);
export default __webpack_public_path__ + "static/media/paperPlane.065ca7bd.svg";
export { ForwardRef as ReactComponent };